import Analytics from "analytics";
import { trackEvent, trackPageView } from "../api/client";

export const analytics = Analytics({
  app: "psychforlife",
  plugins: [
    {
      name: "app-analytics",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      page: ({ payload }: { payload: any }) => {
        try {
          const { properties } = payload;

          trackPageView({
            category: properties.category,
            elementId: properties.elementId,
            additionalDetails: properties.additionalDetails,
          });
        } catch (error) {
          throw new Error(`Failed to track page view: ${error}`);
        }
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      track: ({ payload }: { payload: any }) => {
        try {
          const { event, properties } = payload;
          trackEvent({
            eventName: event,
            category: properties.category,
            elementId: properties.elementId,
            additionalDetails: properties.additionalDetails,
          });
        } catch (error) {
          throw new Error(`Failed to track analytics event: ${error}`);
        }
      },
    },
  ],
});
